var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    id: "Ellipse",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0951 15.3337C21.0951 15.7941 20.7218 16.1673 20.2615 16.1673L10.6078 16.1673L14.1858 19.7437C14.3965 19.9545 14.4789 20.2618 14.4017 20.5497C14.3246 20.8376 14.0996 21.0626 13.8117 21.1397C13.5238 21.2169 13.2165 21.1346 13.0057 20.9238L8.00645 15.9237C7.84977 15.7673 7.76172 15.5551 7.76172 15.3337C7.76172 15.1123 7.84977 14.9 8.00645 14.7437L13.0057 9.74439C13.3315 9.41858 13.8598 9.41853 14.1857 9.74429C14.5115 10.0701 14.5117 10.5983 14.186 10.9242L10.6078 14.5001L20.2622 14.5001C20.7223 14.5005 21.0951 14.8736 21.0951 15.3337L21.0951 15.3337Z",
    id: "Trazado_1499",
    fill: "#EFF3CF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.99b5496792c6555fa4d913166dd4a627.svg";
export { ForwardRef as ReactComponent };